import styled from 'styled-components';
import { BP_TABLET_MAX, BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';

export const InvestmentsFilterSelectSC = styled.div`
  min-width: 460px;
  padding: 12px;
  border-radius: 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  background: white;

  @media (max-width: ${BP_TABLET_MAX}px) {
    width: 100%;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    min-width: auto;
  }

  @media (max-width: 450px) {
    flex-direction: column;

    .selector-text {
      margin-bottom: 10px;
    }
  }
`;
